<template>
    <div class="meetingRecord">
        <div class="tableCont">
            <div class="tabCont">
                <el-tabs
                    v-model="searchForm.status"
                    type="border-card"
                    @tab-click="meetingList"
                    ref="tabs"
                >
                    <el-tab-pane
                        v-for="item in statusList"
                        :key="item.status"
                        :name="item.status"
                    >
                        <span slot="label" class="label"
                            ><!-- <i class="el-icon-box"></i> -->{{
                                item.name
                            }}
                            {{ item.total }}</span
                        >
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-drawer
                title="高级搜索"
                :visible.sync="drawerVisible"
                size="320px"
                class="drawerCont"
                ref="drawer"
                :wrapperClosable="false"
            >
                <el-scrollbar class="scrollbar">
                    <el-form
                        :model="searchForm"
                        label-width="120"
                        class="drawerForm"
                    >
                        <el-form-item label="会议主题" size="small">
                            <el-input
                                clearable
                                placeholder="请输入会议主题"
                                size="small"
                                v-model="searchForm.title"
                                @keydown.enter.native="meetingList"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="会议地点" size="small">
                            <el-input
                                clearable
                                placeholder="请输入会议地点"
                                size="small"
                                v-model="searchForm.address"
                                @keydown.enter.native="meetingList"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="会议日期" size="small">
                            <el-date-picker
                                v-model="searchForm.meeting_date"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="meetingList"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="参会人" size="small">
                            <el-select
                                v-model="conferees"
                                filterable
                                multiple
                                clearable
                                placeholder="请选择参会人"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="地点类型" size="small">
                            <el-select
                                v-model="searchForm.is_custom_room"
                                clearable
                                placeholder="请选择地点类型"
                                @change="meetingList"
                            >
                                <el-option
                                    label="自定义地点"
                                    :value="0"
                                ></el-option>
                                <el-option
                                    label="公司会议室"
                                    :value="1"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建人" size="small">
                            <el-select
                                v-model="user_ids"
                                filterable
                                multiple
                                clearable
                                placeholder="请选择创建人"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="text-align: right">
                            <el-button
                                type="danger"
                                icon="el-icon-refresh-right"
                                size="small"
                                @click="clean"
                            >
                                重置条件
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div class="drawer-footer">
                    <el-button
                        style="width: 100%"
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        @click="meetingList"
                    >
                        查询
                    </el-button>
                </div>
            </el-drawer>
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                    >
                        <el-form-item label="会议主题" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入会议主题"
                                size="mini"
                                v-model="searchForm.title"
                                @keydown.enter.native="meetingList"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="创建人" size="mini">
                            <el-select
                                v-model="user_ids"
                                filterable
                                multiple
                                clearable
                                collapse-tags
                                placeholder="请选择创建人"
                                @change="meetingList"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="地点类型" size="mini">
                            <el-select
                                v-model="searchForm.is_custom_room"
                                clearable
                                placeholder="请选择地点类型"
                                @change="meetingList"
                            >
                                <el-option
                                    label="自定义地点"
                                    :value="0"
                                ></el-option>
                                <el-option
                                    label="公司会议室"
                                    :value="1"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="meetingList(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <template v-for="item in menuAuth">
                            <el-button
                                :key="item.id"
                                type="primary"
                                :icon="item.icon"
                                size="mini"
                                @click="authFunc(item.funcName)"
                            >
                                {{ item.name }}
                            </el-button>
                        </template>
                    </div>
                </div>
                <!-- 高级搜索 -->
                <advancedSearch :drawerVisible.sync="drawerVisible"
                    >高级搜索</advancedSearch
                >
            </div>
            <div class="table" :style="{ height: $store.state.index.screen }">
                <el-table :data="tableData" highlight-current-row height="100%">
                    <el-table-column
                        type="selection"
                        align="center"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="会议主题"
                        property="title"
                        align="left"
                        min-width="300"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        label="会议地点"
                        property="address_name"
                        align="left"
                        show-overflow-tooltip
                        min-width="160"
                    >
                    </el-table-column>
                    <el-table-column
                        label="地点类型"
                        property="is_custom_room"
                        align="left"
                        width="100"
                    >
                        <template slot-scope="scoped">
                            {{
                                scoped.row.is_custom_room == 1
                                    ? "公司会议室"
                                    : "自定义地点"
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="会议日期"
                        align="left"
                        min-width="120"
                    >
                        <template slot-scope="scoped">
                            {{scoped.row.meeting_date}}
                            {{scoped.row.week}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="会议时间"
                        align="left"
                        min-width="120"
                    >
                        <template slot-scope="scoped">
                            <p>
                                {{ scoped.row.meeting_start_time }} ~
                                {{ scoped.row.meeting_end_time }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="参会人数"
                        property="accept_staff"
                        align="left"
                        width="80"
                    >
                        <template slot-scope="scoped">
                            <p class="link" @click="jump(scoped.row)">
                                {{ scoped.row.accept_staff }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="当前状态" align="left" width="80">
                        <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                :type="
                                    scope.row.status == 1
                                        ? 'info'
                                        : scope.row.status == 5
                                        ? 'warning'
                                        : scope.row.status == 10 ||
                                          scope.row.status == 20
                                        ? 'success'
                                        : scope.row.status == 99
                                        ? 'danger'
                                        : ''
                                "
                            >
                                {{ scope.row.status_cn }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        property="user_name"
                        align="left"
                        width="80"
                    >
                    </el-table-column>
                    <el-table-column
                        label="创建时间"
                        property="create_time"
                        align="left"
                        width="140"
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="left"
                        width="200"
                        :fixed="operationFixed"
                    >
                        <template slot-scope="scope">
                            <div class="operation-btns">
                                <span
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="item.status_flag != 4"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        @click="rowDo(scope.row, item)"
                                        >{{ item.name }}</el-button
                                    >
                                    <popConfirm
                                        v-else
                                        :title="item.name"
                                        :buttonText="item.name"
                                        @confirm="rowDo(scope.row, item)"
                                    >
                                    </popConfirm>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>
            <meetingAdd :addVisible.sync="addVisible"></meetingAdd>
            <meetingEdit
                :editVisible.sync="editVisible"
                :tableItem="tableItem"
            ></meetingEdit>
            <meetingDetail
                :detailVisible.sync="detailVisible"
                :tableItem="tableItem"
            ></meetingDetail>
            <meetingConclusion
                :conclusionVisible.sync="conclusionVisible"
                :tableItem="tableItem"
            ></meetingConclusion>
            <meetingConferee
                :confereeVisible.sync="confereeVisible"
                :tableItem="tableItem"
            ></meetingConferee>
        </div>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import pagination from "@/comon/components/pagination";
import advancedSearch from "@/comon/components/advancedSearch";
import popConfirm from "@/comon/components/popConfirm";
import { mapActions } from "vuex";

export default {
    mixins: [tableMixin],

    data() {
        return {
            searchForm: {
                status: "0",
                title: "",
                address: "",
                user_id: "",
                meeting_date: "",
                conferee: "",
                is_custom_room: "",
            },
            conferees: [],
            user_ids: [],
            tableData: [],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
            statusList: [],
            tableItem: {},
            drawerVisible: false,
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            conclusionVisible: false,
            confereeVisible: false,
        };
    },
    methods: {
        ...mapActions(["getStaffSelect"]),
        add() {
            this.addVisible = true;
        },
        clean() {
            this.searchForm = {
                status: "0",
                title: "",
                address: "",
                user_id: "",
                meeting_date: "",
                conferee: "",
                is_custom_room: "",
            };
            this.conferees = [];
            this.user_ids = [];
            this.meetingList();
        },
        closeDrawer() {
            this.drawerVisible = false;
        },
        /**
         * 获取table
         */
        meetingList(page) {
            page ? (this.paginationData.page = 1) : "";
            this.searchForm.conferee = this.conferees.toString();
            this.searchForm.user_id = this.user_ids.toString();
            oaApi
                .meetingList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.statusList = res.ext.tabs;
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.closeDrawer();
                    }
                });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.meetingList();
        },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "编辑") {
                this.editVisible = true;
                this.tableItem = row;
            } else if (item.name == "取消") {
                this.meetingUpdateStatus(item, row.id, 99);
            } else if (item.name == "查看") {
                this.detailVisible = true;
                this.tableItem = row;
            } else if (item.name == "开始") {
                this.meetingUpdateStatus(item, row.id, 5);
            } else if (item.name == "完成") {
                this.meetingUpdateStatus(item, row.id, 10);
            } else if (item.name == "参会") {
                this.meetingAccept(item, row.id);
            } else if (item.name == "总结") {
                this.conclusionVisible = true;
                this.tableItem = row;
            }
        },
        authFunc(funcName) {
            this[funcName]();
        },
        meetingUpdateStatus(item, id, status) {
            /* this.$confirm(`确定${item.name}?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => */
            oaApi.meetingUpdateStatus({ id, status }, "post").then((res) => {
                if (res) {
                    if (res.code == 200) {
                        this.$message.success(`${item.name}成功`);
                        this.meetingList();
                    }
                }
            });
            /* )
                .catch(() => {
                    this.$message.info("已取消操作");
                }); */
        },
        /**
         * 参加会议
         */
        meetingAccept(item, id) {
            this.$confirm(`确定${item.name}?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() =>
                    oaApi.meetingAccept({ m_id: id }, "post").then((res) => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success(`${item.name}成功`);
                                this.meetingList();
                            }
                        }
                    })
                )
                .catch(() => {
                    this.$message.info("已取消操作");
                });
        },
        jump(row) {
            if (row.accept_staff > 0) {
                this.confereeVisible = true;
                this.tableItem = row;
            } else {
                this.$message.warning("暂无参会人员");
            }
        },
        drawerFormKeydown(e) {
            this.meetingList();
            this.$refs.confereesSelect.blur();
        },
        dateChange(val) {
            console.log(val);
        },
    },
    mounted() {
        this.getStaffSelect();
        this.meetingList();
    },
    components: {
        pagination: pagination,
        advancedSearch: advancedSearch,
        popConfirm: popConfirm,
        meetingAdd: () => import("./meetingRecord/add.vue"),
        meetingEdit: () => import("./meetingRecord/edit.vue"),
        meetingDetail: () => import("./meetingRecord/detail.vue"),
        meetingConclusion: () => import("./meetingRecord/conclusion.vue"),
        meetingConferee: () => import("./meetingRecord/conferee.vue"),
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        staffList() {
            return this.$store.state.index.staffList;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
    },
};
</script>
<style lang="scss">
.meetingRecord {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;

    .tableCont {
        width: 100%;
        height: 100%;
        border-left: 1px solid #eee;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            width: 100%;
            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
    }
}
</style>
